import useTypedFlags from "hooks/useTypedFlags";

import {
  ADDITIONAL_FEATURES_BY_TIER,
  BASE_INFO_BY_TIER,
  DETAILS_BY_TIER,
  UPGRADE_BOX_BY_TIER,
  UPGRADE_MARKETING_TIERS,
} from "./constants";
import {
  PRE_OCTOBER_2026_ADDITIONAL_FEATURES_BY_TIER,
  PRE_OCTOBER_2026_BASE_INFO_BY_TIER,
  PRE_OCTOBER_2026_DETAILS_BY_TIER,
  PRE_OCTOBER_2026_UPGRADE_BOX_BY_TIER,
  PRE_OCTOBER_2026_UPGRADE_MARKETING_TIERS,
} from "./preOctober2026Constants";

const useBillingUpgradeOptionsContent = () => {
  const { october2026PricingChanges } = useTypedFlags();

  if (october2026PricingChanges) {
    return {
      marketingTiers: UPGRADE_MARKETING_TIERS,
      baseInfoByTier: BASE_INFO_BY_TIER,
      detailsByTier: DETAILS_BY_TIER,
      additionalFeaturesByTier: ADDITIONAL_FEATURES_BY_TIER,
      upgradeBoxByTier: UPGRADE_BOX_BY_TIER,
    };
  }

  return {
    marketingTiers: PRE_OCTOBER_2026_UPGRADE_MARKETING_TIERS,
    baseInfoByTier: PRE_OCTOBER_2026_BASE_INFO_BY_TIER,
    detailsByTier: PRE_OCTOBER_2026_DETAILS_BY_TIER,
    additionalFeaturesByTier: PRE_OCTOBER_2026_ADDITIONAL_FEATURES_BY_TIER,
    upgradeBoxByTier: PRE_OCTOBER_2026_UPGRADE_BOX_BY_TIER,
  };
};

export default useBillingUpgradeOptionsContent;
